import { useCallback, useState } from 'react';
import { useLogin } from '../../../../hooks/useLogin';
import { isLoginResultSuccess, loginByEmail } from '../../../../api/jwtAuth';
import { ApiTokenType } from '../../../../context/AuthContext';
import { loginByAuthorizationCode } from '../../../../api/jwtAuth/jwtAuthApi';

export const useJwtAuth = () => {
  const [loginErrors, setLoginErrors] = useState<boolean>(false);
  const login = useLogin();

  const doLogin = useCallback(
    async (email: string, password: string) => {
      const loginResult = await loginByEmail(email, password);
      if (isLoginResultSuccess(loginResult)) {
        login(`Bearer ${loginResult.accessToken}`, ApiTokenType.JWT);
        return 'success';
      } else {
        setLoginErrors(true);
      }
    },
    [login],
  );

  const doLoginByAuthorizationCode = useCallback(
    async (authorizationCode: string) => {
      const loginResult = await loginByAuthorizationCode(authorizationCode);
      if (isLoginResultSuccess(loginResult)) {
        login(`Bearer ${loginResult.accessToken}`, ApiTokenType.JWT);
        return 'success';
      } else {
        setLoginErrors(true);
      }
    },
    [login],
  );

  return { doLogin, doLoginByAuthorizationCode, loginErrors };
};
